define(
  'common/module/media/Serum.MediaMetadata',['jquery', 'module'],
  function ($, module) {
    var PSAPI_SERIES_PATH = 'series/{seriesId}/latestOrNextEpisode/mediaelement';
    var METADATA_PATH = 'playback/metadata/';

    var cache = {};

    function getJson (url) {
      var requestSettings = {
        type: 'GET',
        url: url,
        dataType: 'json'
      };

      return $.ajax(requestSettings)
    }

    function getLatestSeriesEpisodeId (id) {
      var url = module.config().PS_VIDEO_API_URL + PSAPI_SERIES_PATH.replace('{seriesId}', id);
      return getJson(url)
        .then(function (data) {
          return data.id;
        });
    }

    function getMediaData (id) {
      var url = module.config().PS_VIDEO_API_URL + METADATA_PATH + id;

      if (cache[id]) {
        return $.Deferred()
          .resolve()
          .then(function () {
            return cache[id];
          });
      }

      return getJson(url)
        .then(function (data) {
          cache[id] = data;
          return data;
        });
    }

    function get (id, isSeries) {
      if (isSeries) {
        return getLatestSeriesEpisodeId(id)
          .then(function (episodeId) {
            return getMediaData(episodeId);
          })
      }

      return getMediaData(id);
    }

    function getAspectRatio (videoID, isSeries) {
      if (videoID) {
        return get(videoID, isSeries === true)
          .then(function (metaData) {
            return metaData.displayAspectRatio;
          });
      }

      return null;
    }

    function getLiveStatus (videoID, isSeries) {
      if (videoID) {
        return get(videoID, isSeries === true)
          .then(function (metaData) {
            var liveStatus = {};

            liveStatus.isLive = metaData.streamingMode === 'live' &&
              metaData.playability === 'playable';

            if (metaData.availability && metaData.availability.live && metaData.availability.live.transmissionInterval) {
              liveStatus.startTime = metaData.availability.live.transmissionInterval.from
            }

            return liveStatus;
          });
      }

      return {};
    }

    return {
      get: get,
      getLatestSeriesEpisodeId: getLatestSeriesEpisodeId,
      getLiveStatus: getLiveStatus,
      getAspectRatio: getAspectRatio
    }
  }
);

